import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sidenav-content-offline-recharge',
  templateUrl: './sidenav-content-offline-recharge.component.html',
  styleUrls: ['./sidenav-content-offline-recharge.component.scss']
})
export class SidenavContentOfflineRechargeComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();

  CloseAction() {
    this.close.emit(true);
  }
  constructor() { }
  ngOnInit() {
  }

}
